<template>
  <form name="form">
    <b-modal id="ChangeRoles" hide-footer size="xl">
      <template #modal-title> Zmiana uprawnień </template>

      <div class="row">
        <div class="col">
          <label for="ProducerName" class="form-label">Nazwa Konta</label>
          <input
            type="text"
            class="form-control"
            id="userName"
            v-model="user.name"
            disabled="true"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label for="password" class="form-label">Uprawnienia</label>
          <v-select
            multiple
            :options="roles"
            label="name"
            v-model="selectedRoles"
          ></v-select>
        </div>
      </div>
      <div class="col align-self-end div-form-buttons-area">
        <button class="btn btn-primary" type="button" @click="SaveData">
          Zapisz
        </button>
        <button class="btn btn-warning" type="button" @click="CloseWindow">
          Zamknij
        </button>
      </div>
    </b-modal>
  </form>
</template>

<script>
import urlConfig from "../../../../mixins/url";
import toastr from "../../../../mixins/toastr";
import UserService from "../../../../services/user.service";

export default {
  components: {},
  mixins: [urlConfig, toastr],
  props: ["user"],
  computed: {
    roles() {
      return this.$store.state.userFormData.roles;
    },
    userRoles() {
      return this.user.roles;
    },
  },
  mounted() {
    var that = this;
    this.$root.$on("bv::modal::show", () => {
      that.$nextTick(function () {
        if (that.user.roles) {
          that.user.roles.forEach((role) => that.selectedRoles.push(role));
        }
      });
    });

    this.$root.$on("bv::modal::hide", () => {
      that.selectedRoles = [];
    });
  },
  data() {
    return {
      modalName: "ChangeRoles",
      selectedRoles: [],
    };
  },
  methods: {
    CloseWindow() {
      this.$bvModal.hide(this.modalName);
    },
    SaveData() {
      var that = this;
      UserService.changeRoles(this.user.id, this.selectedRoles)
        .then(() => {
          that.DisplaySuccess(
            "Sukces!",
            "Uprawnienia dla użytkownika " +
              that.user.name +
              " zostały zmienione"
          );
          that.$emit("UserRolesChanged");
          this.$bvModal.hide(that.modalName);
        })
        .catch((err) => {
          that.DisplayError("Błąd!", err);
        });
    },
  },
};
</script>